document.addEventListener('DOMContentLoaded', function () {

  /* ============ Mobile Drawer ============ */
  var drawer = document.querySelector('[data-mobile-drawer]');
  var overlay = document.querySelector('[data-mobile-overlay]');
  var openBtns = document.querySelectorAll('[data-open-mobile-menu]');
  var closeBtns = document.querySelectorAll('[data-close-mobile-menu]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
  }
  openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
  closeBtns.forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', function(){ closeDrawer(); closeFilter(); closeSearch(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeFilter(); closeSearch(); } });

  /* ============ Mega Menu (desktop "Shop Knives" dropdown) ============ */
  var megaWraps = document.querySelectorAll('[data-mega-menu]');
  var megaHoverTimer = null;

  function closeAllMegaMenus() {
    megaWraps.forEach(function (w) {
      w.classList.remove('is-open');
      var trigger = w.querySelector('.nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  megaWraps.forEach(function (wrap) {
    var trigger = wrap.querySelector('.nav-item__trigger');
    if (!trigger) return;

    function openThis() {
      megaWraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeThis() {
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    // Hover-intent open/close for desktop (small delay avoids flicker when
    // moving the cursor from the trigger down into the panel).
    wrap.addEventListener('mouseenter', function () {
      if (window.matchMedia('(max-width:980px)').matches) return;
      clearTimeout(megaHoverTimer);
      openThis();
    });
    wrap.addEventListener('mouseleave', function () {
      if (window.matchMedia('(max-width:980px)').matches) return;
      megaHoverTimer = setTimeout(closeThis, 160);
    });

    // Click toggle (touch devices / keyboard users where hover doesn't apply).
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = wrap.classList.contains('is-open');
      closeAllMegaMenus();
      if (!isOpen) openThis();
    });
  });

  // Close on outside click.
  document.addEventListener('click', function (e) {
    var clickedInsideAnyMega = Array.prototype.some.call(megaWraps, function (w) { return w.contains(e.target); });
    if (!clickedInsideAnyMega) closeAllMegaMenus();
  });
  // Close on Escape (in addition to drawer/filter/search above).
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllMegaMenus(); });
  // Close if the sticky header hides itself while scrolling down.
  window.addEventListener('scroll', function () { closeAllMegaMenus(); }, { passive: true });

  /* ============ Mobile Filter Panel (collection page) ============ */
  var filterPanel = document.querySelector('[data-filter-panel]');
  var filterOpenBtns = document.querySelectorAll('[data-open-filter]');
  var filterCloseBtns = document.querySelectorAll('[data-close-filter]');
  function openFilter() {
    if (filterPanel) filterPanel.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('drawer-open');
  }
  function closeFilter() {
    if (filterPanel) filterPanel.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('drawer-open');
  }
  filterOpenBtns.forEach(function (b) { b.addEventListener('click', openFilter); });
  filterCloseBtns.forEach(function (b) { b.addEventListener('click', closeFilter); });

  /* ============ Search Overlay ============ */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchOpenBtns = document.querySelectorAll('[data-open-search]');
  var searchCloseBtns = document.querySelectorAll('[data-close-search]');
  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-active');
      var input = searchOverlay.querySelector('input');
      if (input) setTimeout(function(){ input.focus(); }, 200);
    }
  }
  function closeSearch() {
    if (searchOverlay) searchOverlay.classList.remove('is-active');
  }
  searchOpenBtns.forEach(function (b) { b.addEventListener('click', openSearch); });
  searchCloseBtns.forEach(function (b) { b.addEventListener('click', closeSearch); });
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  /* ============ Sticky / Transparent Header Scroll Class ============ */
  /* Matches the Avone reference "smart sticky" header pattern:
     - Adds is-scrolled once past a small threshold (background/shadow kicks in)
     - Hides the header (slides up via transform) while actively scrolling DOWN
     - Reveals the header again the moment the user scrolls UP, even slightly
     - Always visible near the very top of the page */
  var header = document.querySelector('[data-site-header]');
  var lastScrollY = window.scrollY;
  var scrollTicking = false;
  var runStartY = window.scrollY;  /* scrollY where the current continuous-direction run began */
  var runDir = 0;                  /* 1 = moving down, -1 = moving up, 0 = idle */
  var HIDE_TRAVEL = 12;   /* net px of continuous downward travel required before hiding */
  var REVEAL_TRAVEL = 6;  /* net px of continuous upward travel required before revealing (quicker to reveal than hide, matches reference feel) */

  function onScrollHeader() {
    if (!header) return;
    var currentY = Math.max(0, window.scrollY);
    var delta = currentY - lastScrollY;
    var dir = delta > 0 ? 1 : (delta < 0 ? -1 : runDir);

    if (currentY > 4) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');

    /* Whenever the scroll direction flips, restart the "run" measurement from
       here — this smooths out tiny jitter/rebound deltas from trackpads and
       momentum scrolling so the header doesn't flicker hide/show rapidly. */
    if (dir !== runDir) {
      runDir = dir;
      runStartY = lastScrollY;
    }

    var traveled = (currentY - runStartY) * runDir; /* always >= 0 in the current run direction */
    var interactionOpen = document.body.classList.contains('drawer-open');
    var isHidden = header.classList.contains('is-hidden');

    if (interactionOpen || currentY <= 80) {
      /* Never hide while a drawer/overlay is open, or near the very top */
      header.classList.remove('is-hidden');
    } else if (!isHidden && dir === 1 && traveled > HIDE_TRAVEL) {
      header.classList.add('is-hidden');
      closeSearch();
      runStartY = currentY;
    } else if (isHidden && dir === -1 && traveled > REVEAL_TRAVEL) {
      header.classList.remove('is-hidden');
      runStartY = currentY;
    }

    lastScrollY = currentY;
    scrollTicking = false;
  }

  function requestHeaderScrollTick() {
    if (!scrollTicking) {
      window.requestAnimationFrame(onScrollHeader);
      scrollTicking = true;
    }
  }

  onScrollHeader();
  window.addEventListener('scroll', requestHeaderScrollTick, { passive: true });

  /* ============ Scroll To Top Button ============ */
  var scrollTopBtn = document.querySelector('[data-scroll-top]');
  function onScrollTopVisibility() {
    if (!scrollTopBtn) return;
    if (window.scrollY > 480) scrollTopBtn.classList.add('is-visible');
    else scrollTopBtn.classList.remove('is-visible');
  }
  onScrollTopVisibility();
  window.addEventListener('scroll', onScrollTopVisibility, { passive: true });
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ============ Scroll-Reveal Animations (IntersectionObserver) ============ */
  var animatedEls = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animatedEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    animatedEls.forEach(function (el) { io.observe(el); });
  } else {
    animatedEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============ Luxury Banner Parallax ============ */
  /* Cinematic scroll-driven parallax for the full-bleed luxury banners
     (Signature Collection / Web Exclusives / Custom Engraving / Knife
     Sets). Each banner's oversized background <img> (.luxury-banner__bg)
     is translated a fraction of the section's distance from viewport
     center, updated via requestAnimationFrame for smooth 60fps motion.
     Disabled entirely for prefers-reduced-motion or narrow mobile widths
     to keep things calm and battery-friendly. */
  var parallaxBanners = Array.prototype.slice.call(document.querySelectorAll('.luxury-banner'));
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (parallaxBanners.length && !prefersReducedMotion) {
    var parallaxTicking = false;
    function updateParallax() {
      var vh = window.innerHeight;
      parallaxBanners.forEach(function (section) {
        var bg = section.querySelector('.luxury-banner__bg');
        if (!bg) return;
        var rect = section.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return; /* skip far off-screen sections */
        var centerOffset = (rect.top + rect.height / 2) - vh / 2;
        var strength = window.matchMedia('(max-width:720px)').matches ? 0.06 : 0.16;
        var translate = Math.max(-70, Math.min(70, centerOffset * strength * -1));
        bg.style.transform = 'translateY(' + translate.toFixed(1) + 'px)';
      });
      parallaxTicking = false;
    }
    function requestParallaxTick() {
      if (!parallaxTicking) {
        window.requestAnimationFrame(updateParallax);
        parallaxTicking = true;
      }
    }
    updateParallax();
    window.addEventListener('scroll', requestParallaxTick, { passive: true });
    window.addEventListener('resize', requestParallaxTick);
  }

  /* ============ Hero Slideshow ============ */
  var heroShow = document.querySelector('[data-hero-slideshow]');
  if (heroShow) {
    var slides = heroShow.querySelectorAll('[data-hero-slide]');
    var dots = heroShow.querySelectorAll('[data-hero-dot]');
    var prevBtn = heroShow.querySelector('[data-hero-prev]');
    var nextBtn = heroShow.querySelector('[data-hero-next]');
    var current = 0;
    var autoTimer = null;
    var AUTO_MS = 5000; /* matches Avone reference swiper autoplay delay (5000ms) */

    function goTo(idx) {
      idx = (idx + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAuto() {
      stopAuto();
      if (slides.length > 1) autoTimer = setInterval(next, AUTO_MS);
    }
    function stopAuto() {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = null;
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); startAuto(); });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAuto(); });

    heroShow.addEventListener('mouseenter', stopAuto);
    heroShow.addEventListener('mouseleave', startAuto);

    /* touch swipe */
    var touchStartX = 0;
    heroShow.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    heroShow.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(dx) > 40) { dx > 0 ? prev() : next(); startAuto(); }
    }, { passive: true });

    goTo(0);
    startAuto();
  }

  /* ============ Countdown Timer ============ */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target;
    var attr = el.dataset.countdown;
    if (attr) {
      target = new Date(attr).getTime();
    }
    if (!target || isNaN(target)) {
      target = Date.now() + (3 * 24 * 60 * 60 * 1000) + (14 * 60 * 60 * 1000); // fallback 3d14h
    }
    var dEl = el.querySelector('[data-cd-days]');
    var hEl = el.querySelector('[data-cd-hours]');
    var mEl = el.querySelector('[data-cd-mins]');
    var sEl = el.querySelector('[data-cd-secs]');
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ============ Combo / Bundle Savings Calculator ============ */
  document.querySelectorAll('[data-combo]').forEach(function (combo) {
    var checks = combo.querySelectorAll('[data-combo-check]');
    var totalEl = combo.querySelector('[data-combo-total]');
    var compareEl = combo.querySelector('[data-combo-compare]');
    var saveEl = combo.querySelector('[data-combo-save]');
    var addBtn = combo.querySelector('[data-combo-add]');
    function recalc() {
      var total = 0, compare = 0;
      checks.forEach(function (c) {
        if (c.checked) {
          total += parseFloat(c.dataset.price || '0');
          compare += parseFloat(c.dataset.compare || c.dataset.price || '0');
        }
      });
      if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
      if (compareEl) compareEl.textContent = compare > total ? ('$' + compare.toFixed(2)) : '';
      if (saveEl) {
        var save = compare - total;
        saveEl.textContent = save > 0 ? ('Save $' + save.toFixed(2)) : '';
        saveEl.style.display = save > 0 ? '' : 'none';
      }
      if (addBtn) {
        var count = combo.querySelectorAll('[data-combo-check]:checked').length;
        addBtn.textContent = 'Add ' + count + ' to Cart';
        addBtn.disabled = count === 0;
      }
    }
    checks.forEach(function (c) { c.addEventListener('change', recalc); });
    recalc();
  });

  /* ============ Quantity Steppers ============ */
  document.querySelectorAll('[data-qty-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('[data-quantity-input]');
      if (!wrapper) return;
      var input = wrapper.querySelector('input[type="number"]');
      if (!input) return;
      var step = parseInt(input.step || '1', 10);
      var min = parseInt(input.min || '1', 10);
      var val = parseInt(input.value || '1', 10);
      if (btn.dataset.qtyButton === 'plus') val += step;
      else val = Math.max(min, val - step);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ============ Variant Chip Selection ============ */
  document.querySelectorAll('[data-variant-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = chip.closest('[data-variant-group]');
      if (group) {
        group.querySelectorAll('[data-variant-chip]').forEach(function (c) { c.classList.remove('is-active'); });
      }
      chip.classList.add('is-active');
      var input = chip.querySelector('input');
      if (input) input.checked = true;
    });
  });

  /* ============ Product Gallery Thumbnails ============ */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.full) {
          mainImg.style.opacity = 0;
          setTimeout(function () {
            mainImg.src = thumb.dataset.full;
            mainImg.style.opacity = 1;
          }, 160);
        }
      });
    });
  });

  /* ============ Product Tabs ============ */
  document.querySelectorAll('[data-tabs]').forEach(function (tabsWrap) {
    var buttons = tabsWrap.querySelectorAll('[data-tab-target]');
    var panels = tabsWrap.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var target = btn.dataset.tabTarget;
        var panel = tabsWrap.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ============ Add to Cart Micro-interaction (static preview) ============ */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.tagName === 'BUTTON') e.preventDefault();
      if (btn.classList.contains('is-added')) return;
      var original = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = '<span class="add-icon">✓</span> Added to Cart';
      var cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        cartCount.textContent = (parseInt(cartCount.textContent || '0', 10) + 1);
        cartCount.style.animation = 'none';
        requestAnimationFrame(function () { cartCount.style.animation = 'cartBounce .5s ease'; });
      }
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.innerHTML = original;
      }, 1800);
    });
  });

  /* ============ Edge Slider (Category rail) — genuine horizontal
     touch-swipe carousel matching the reference video: drag-to-scroll on
     desktop mouse, native momentum touch-swipe on mobile, snap-to-card,
     round prev/next arrows, and active dot pagination that updates as the
     user swipes/scrolls (not just on button click). ============ */
  document.querySelectorAll('[data-edge-slider]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-edge-track]');
    if (!track) return;
    var prevBtn = wrap.querySelector('[data-edge-prev]');
    var nextBtn = wrap.querySelector('[data-edge-next]');
    var dots = wrap.querySelectorAll('[data-edge-dot]');

    function cardWidth() {
      var card = track.firstElementChild;
      if (!card) return 260;
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * cardWidth(), behavior: 'smooth' });
      });
    });

    /* Vertical mouse-wheel scrolls the rail sideways on desktop, same as
       the old product slider used to do (feature-parity for Top Sellers /
       Related Blades now that they ride this shared carousel). */
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      }
    }, { passive: false });

    /* Prevent the browser's native image drag-out gesture from hijacking
       the slide: cards/tiles are largely full-bleed <img> elements, and a
       mousedown+mousemove starting directly on one is otherwise recognized
       by the browser as "drag this image" after ~2px of movement — once
       that native drag takes over, our own mousemove handler below stops
       receiving events and the slider appears to silently freeze. */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Mouse drag-to-scroll for desktop (touch already scrolls natively) */
    var isDown = false, startX = 0, startScroll = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = startScroll - (e.pageX - startX);
    });

    /* Keep dot pagination in sync with real scroll position (drag/swipe) */
    if (dots.length) {
      var syncTimer = null;
      track.addEventListener('scroll', function () {
        if (syncTimer) clearTimeout(syncTimer);
        syncTimer = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / cardWidth());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }, 80);
      }, { passive: true });
    }
  });

  /* ============ Ticker / Marquee duplication for seamless loop ============ */
  document.querySelectorAll('[data-ticker-track]').forEach(function (track) {
    if (track.dataset.duplicated) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicated = 'true';
  });
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    if (track.dataset.duplicated) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicated = 'true';
  });

  /* ============ Announcement Bar Arrow Nav (cycles ticker messages by scroll) ============ */
  document.querySelectorAll('[data-announce-prev],[data-announce-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ticker = btn.closest('.announcement-bar__inner').querySelector('.announcement-bar__ticker');
      if (!ticker) return;
      var track = ticker.querySelector('[data-ticker-track]');
      if (!track) return;
      var w = track.scrollWidth / 2;
      var dir = btn.hasAttribute('data-announce-next') ? 1 : -1;
      track.style.transition = 'transform .4s ease';
      track.style.animationPlayState = 'paused';
    });
  });

  /* ============ Promo Banner Reveal (Web Exclusives / EDC / Custom Shop / New Releases) ============ */
  var promoBanners = document.querySelectorAll('.promo-banner');
  if ('IntersectionObserver' in window && promoBanners.length) {
    var promoIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          promoIo.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
    promoBanners.forEach(function (el) { promoIo.observe(el); });
  } else {
    promoBanners.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============ Stats / Trust Counter Strip — count-up on scroll into view ============ */
  var statsStrip = document.querySelector('[data-stats-strip]');
  if (statsStrip) {
    var statNums = statsStrip.querySelectorAll('[data-count-to]');
    var statsAnimated = false;
    function runStatsCountUp() {
      if (statsAnimated) return;
      statsAnimated = true;
      statNums.forEach(function (el) {
        var target = parseFloat(el.dataset.countTo || '0');
        var suffix = el.dataset.countSuffix || '';
        var prefix = el.dataset.countPrefix || '';
        var duration = 1600;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3); /* ease-out-cubic */
          var current = Math.round(target * eased);
          el.textContent = prefix + current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toLocaleString() + suffix;
        }
        requestAnimationFrame(step);
      });
    }
    if ('IntersectionObserver' in window) {
      var statsIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runStatsCountUp();
            statsIo.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 });
      statsIo.observe(statsStrip);
    } else {
      runStatsCountUp();
    }
  }

  /* ============ Searchable Full Product + Category Catalog ============ */
  var catalogSection = document.querySelector('[data-catalog-section]');
  if (catalogSection) {
    var catalogInput = catalogSection.querySelector('[data-catalog-input]');
    var catalogClear = catalogSection.querySelector('[data-catalog-clear]');
    var catalogSearchWrap = catalogSection.querySelector('.catalog-search');
    var catalogTabs = catalogSection.querySelectorAll('[data-catalog-tab]');
    var catalogCards = catalogSection.querySelectorAll('[data-catalog-item]');
    var catalogEmpty = catalogSection.querySelector('[data-catalog-empty]');
    var catalogCountLive = catalogSection.querySelector('[data-catalog-count]');
    var activeCat = 'all';

    function applyCatalogFilter() {
      var q = (catalogInput && catalogInput.value || '').trim().toLowerCase();
      var visible = 0;
      catalogCards.forEach(function (card) {
        var matchesCat = activeCat === 'all' || card.getAttribute('data-catalog-cat') === activeCat;
        var matchesSearch = !q || (card.getAttribute('data-catalog-search') || '').indexOf(q) !== -1;
        var show = matchesCat && matchesSearch;
        if (show) { card.removeAttribute('data-catalog-hidden'); visible++; }
        else card.setAttribute('data-catalog-hidden', '');
      });
      if (catalogEmpty) catalogEmpty.classList.toggle('is-visible', visible === 0);
      if (catalogCountLive) {
        catalogCountLive.innerHTML = 'Showing <strong>' + visible + '</strong> of <strong>' + catalogCards.length + '</strong> hand-forged knives';
      }
      if (catalogSearchWrap) catalogSearchWrap.classList.toggle('has-value', !!q);
    }

    if (catalogInput) {
      catalogInput.addEventListener('input', applyCatalogFilter);
    }
    if (catalogClear) {
      catalogClear.addEventListener('click', function () {
        if (catalogInput) { catalogInput.value = ''; catalogInput.focus(); }
        applyCatalogFilter();
      });
    }
    catalogTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        catalogTabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        activeCat = tab.getAttribute('data-catalog-tab') || 'all';
        applyCatalogFilter();
      });
    });

    applyCatalogFilter();
  }

  /* ============ Tabbed Product Showcase (Most Popular / Top Sellers / New Releases) ============ */
  var showcaseTabsWrap = document.querySelector('[data-showcase-tabs]');
  var showcasePanelsWrap = document.querySelector('[data-showcase-panels]');
  if (showcaseTabsWrap && showcasePanelsWrap) {
    var showcaseTabBtns = showcaseTabsWrap.querySelectorAll('[data-showcase-tab]');
    var showcasePanels = showcasePanelsWrap.querySelectorAll('[data-showcase-panel]');
    showcaseTabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-showcase-tab');
        showcaseTabBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        showcasePanels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-showcase-panel') === key);
        });
      });
    });
  }

  /* ============ Collection sort (static demo - no real reload) ============ */
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var grid = document.querySelector('[data-product-grid]');
      if (grid) {
        grid.style.transition = 'opacity .3s ease';
        grid.style.opacity = '0.3';
        setTimeout(function () { grid.style.opacity = '1'; }, 300);
      }
    });
  });

});
